import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  select(event) {
    event.preventDefault()
    this.setChecked(event.currentTarget.dataset.recordType, true)
  }

  clear(event) {
    event.preventDefault()
    this.setChecked(event.currentTarget.dataset.recordType, false)
  }

  setChecked(recordType, checked) {
    this.element.querySelectorAll(`[data-athlete-duplicate-record-type="${recordType}"]`).forEach((input) => {
      input.checked = checked
    })
  }
}
